<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="account">Bank Account</label>
            <Dropdown v-model="account" :options="bankList"
                      optionLabel="name"
                      class="dropDown" :filter=true
                      :showClear="true" id="account"
                      placeholder="Select Bank">
            </Dropdown>

          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="searchPartyStatement"
                    class="p-button-raised" label="Search" icon="pi pi-search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button icon="pi pi-refresh" label="Reset"
                    v-if="this.postDateChequeList.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning"/>
          </div>
        </div>
      </form>
      <!-- DataTable for PartyStatement -->
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <a href="#" @click.prevent="exportCSV()" v-if="this.postDateChequeList.length > 0">
            <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
          </a>
          <DataTable :value="postDateChequeList"
                     :paginator="true"
                     :rows="10" :filters="filters"
                     class="p-datatable-responsive-demo p-datatable-gridlines"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">{{ sl.index + 1 }}</template>
            </Column>
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Vou Type" field="moduleType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>

            <Column :sortable="true" header="Cheque Date" field="chequeDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Cheque Number" field="chequeNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Deposited" bodyStyle="color:#00a65a;text-align: right" field="debitBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Withdraw" bodyStyle="color:#dd4b39;text-align: right"
                    field="creditBalance" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <!-- {{this.$store.state}} -->
            <Column header="Clear Date" field="chequeClearingDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeClearingDateNepali']"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      clearDate: null,
      postDateChequeList: [],
      bankList: [],
      account: '',
      accountMasterId: null,
      englishDateEnabled: true,
      filters: {}
    }
  },
  mounted() {
    this.bank()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async bank() {
      let response = await this.$store.dispatch('loadBankList')
      this.bankList = response.data.data
    },
    async searchPartyStatement() {
      if (this.account === '' || this.account === null) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one bank!', life: 10000})
        return
      }
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let bankStatementObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        bankId: this.accountMasterId
      }

      this.loading = true
      let response = await this.$store.dispatch('loadPostDateChequeCleared', bankStatementObject)
      this.loading = false
      this.postDateChequeList = response.data.data
      this.postDateChequeList.forEach(data => {
        this.clearDate = data.chequeClearingDate
      })
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      } else if (response.data.data.length > 0) {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else if (response.data.data.length === 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'No list available!', life: 10000})
      }
    },
    addChequeClearDate() {
      this.postDateChequeList.forEach(pdc => {
        pdc.chequeClearingDate = this.clearDate
      })
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.bankStatementReportList = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// postDatedChequeDetailCleared.vue?95caa7c4